import { useEffect, useState } from "react";
import { ChevronRight } from "lucide-react";
import { Link } from "wouter";
import { useI18n } from "../lib/i18n";

type MobileSettingsBreadcrumbProps = {
  currentLabel: string;
  showSettings?: boolean;
  parent?: { label: string; onBack: () => void };
};

/** Linked Settings pages share navigation without adding hidden desktop headings. */
export function MobileSettingsBreadcrumb({ currentLabel, showSettings = true, parent }: MobileSettingsBreadcrumbProps) {
  const { t } = useI18n();
  const [isMobile, setIsMobile] = useState(() => window.matchMedia("(max-width: 639px)").matches);
  useEffect(() => {
    const media = window.matchMedia("(max-width: 639px)");
    const updateViewport = () => setIsMobile(media.matches);
    media.addEventListener("change", updateViewport);
    return () => media.removeEventListener("change", updateViewport);
  }, []);

  if (!isMobile) return null;
  return <nav className="settings-linked-breadcrumb" aria-label={t("settings.title")}>
    <Link href="/dashboard">{t("dashboard.accountMenu.account")}</Link>
    <ChevronRight aria-hidden="true" />
    {showSettings && <>
      {parent ? <button type="button" onClick={parent.onBack}>{parent.label}</button> : <Link href="/settings">{t("settings.title")}</Link>}
      <ChevronRight aria-hidden="true" />
    </>}
    <h1 aria-current="page">{currentLabel}</h1>
  </nav>;
}
